import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  // 公开页面
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/public/SoftwareDev.vue'),
    meta: { requiresAuth: false, title: '软件开发' }
  },
  {
    path: '/online-sms',
    name: 'OnlineSms',
    component: () => import('../views/public/OnlineSms.vue'),
    meta: { requiresAuth: false, title: '在线接码' }
  },
  {
    path: '/rent-number',
    name: 'SoftwareDev',
    component: () => import('../views/public/SoftwareDev.vue'),
    meta: { requiresAuth: false, title: '软件开发' }
  },
  {
    path: '/esim-page',
    name: 'LotteryPage',
    component: () => import('../views/public/LotteryPage.vue'),
    meta: { requiresAuth: false, title: 'eSIM' }
  },
  {
    path: '/agent',
    name: 'LiveChat',
    component: () => import('../views/public/LiveChatPage.vue'),
    meta: { requiresAuth: false, title: '在线客服' }
  },
  {
    path: '/client-download',
    name: 'ClientDownload',
    component: () => import('../views/public/ClientDownload.vue'),
    meta: { requiresAuth: false, title: '客服客户端下载' }
  },
  {
    path: '/chat/c/:channel_code',
    name: 'VisitorChat',
    component: () => import('../views/public/VisitorChat.vue'),
    meta: { requiresAuth: false, layout: 'none', title: '在线客服' }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/public/Login.vue'),
    meta: { requiresAuth: false, title: '登录' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/public/Register.vue'),
    meta: { requiresAuth: false, title: '注册' }
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import('../views/public/Help.vue'),
    meta: { requiresAuth: false, title: '帮助中心' }
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('../views/public/Blog.vue'),
    meta: { requiresAuth: false, title: '博客' }
  },
  {
    path: '/article/:id',
    name: 'ArticleDetail',
    component: () => import('../views/public/ArticleDetail.vue'),
    meta: { requiresAuth: false, title: '文章详情' }
  },
  {
    path: '/api-docs',
    name: 'ApiDocs',
    component: () => import('../views/public/ApiDocs.vue'),
    meta: { requiresAuth: false, title: 'API文档' }
  },
  // 会员中心 (需要登录)
  {
    path: '/member',
    component: () => import('../views/member/MemberLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'receive-sms',
        name: 'ReceiveSms',
        component: () => import('../views/member/ReceiveSms.vue'),
        meta: { title: '接码大厅' }
      },
      {
        path: 'premium-sms',
        name: 'PremiumSms',
        component: () => import('../views/member/PremiumSms.vue'),
        meta: { title: '高级接码' }
      },
      {
        path: 'rent-number',
        name: 'RentNumber',
        component: () => import('../views/member/RentNumber.vue'),
        meta: { title: '租号' }
      },
      {
        path: 'esim',
        name: 'Esim',
        component: () => import('../views/member/Esim.vue'),
        meta: { title: 'eSIM' }
      },
      {
        path: 'recharge',
        name: 'Recharge',
        component: () => import('../views/member/Recharge.vue'),
        meta: { title: '充值' }
      },
      {
        path: 'loyalty',
        name: 'Loyalty',
        component: () => import('../views/member/Loyalty.vue'),
        meta: { title: '忠诚度' }
      },
      {
        path: 'earn',
        name: 'Earn',
        component: () => import('../views/member/Earn.vue'),
        meta: { title: '赚钱' }
      },
      {
        path: 'partnership',
        name: 'Partnership',
        component: () => import('../views/member/Partnership.vue'),
        meta: { title: '合作伙伴' }
      },
      {
        path: 'api',
        name: 'MemberApi',
        component: () => import('../views/member/MemberApi.vue'),
        meta: { title: 'API管理' }
      },
      {
        path: 'instructions',
        name: 'Instructions',
        component: () => import('../views/member/Instructions.vue'),
        meta: { title: '使用说明' }
      },
      {
        path: 'feedback',
        name: 'Feedback',
        component: () => import('../views/member/Feedback.vue'),
        meta: { title: '反馈' }
      },
      {
        path: 'help',
        name: 'MemberHelp',
        component: () => import('../views/member/MemberHelp.vue'),
        meta: { title: '帮助中心' }
      },
      {
        path: 'chat-manage',
        name: 'ChatManage',
        component: () => import('../views/member/ChatManage.vue'),
        meta: { title: '客服管理' }
      },
      {
        path: 'reception-records',
        name: 'ReceptionRecords',
        component: () => import('../views/member/ReceptionRecords.vue'),
        meta: { title: '接待记录' }
      },
      {
        path: 'chat-plan',
        name: 'ChatPlan',
        component: () => import('../views/member/ChatPlan.vue'),
        meta: { title: '客服套餐' }
      },
	  {
        path: 'chat-settings',
        name: 'ChatSettings',
        component: () => import('../views/member/ChatSettings.vue'),
        meta: { title: '客服设置' }
      },
      {
        path: 'agent-manage',
        name: 'AgentManage',
        component: () => import('../views/member/AgentManage.vue'),
        meta: { title: '代理管理' }
      },
      {
        path: 'lottery-bets',
        name: 'LotteryBets',
        component: () => import('../views/member/LotteryBets.vue'),
        meta: { title: '彩票投注' }
      },
      {
        path: 'settings',
        name: 'MemberSettings',
        component: () => import('../views/member/MemberSettings.vue'),
        meta: { title: '账号设置' }
      },
      {
        path: 'profile',
        name: 'MemberProfile',
        component: () => import('../views/member/MemberProfile.vue'),
        meta: { title: '个人资料' }
      }
    ]
  },
  // 404
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

// 解决 NavigationDuplicated 错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

// 路由守卫
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn
  if (to.meta.requiresAuth && !isLoggedIn) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

// 路由切换后更新浏览器标题
router.afterEach((to) => {
  const title = to.meta.title || 'VTO TOP'
  document.title = title + ' - VTO TOP'
})

// 路由切换后更新浏览器标题
router.afterEach((to) => {
  const title = to.meta.title || 'VTO TOP'
  document.title = title + ' - VTO TOP'
})

// 路由切换后更新浏览器标题
router.afterEach((to) => {
  const title = to.meta.title || 'VTO TOP'
  document.title = title + ' - VTO TOP'
})

// 路由切换后更新浏览器标题
router.afterEach((to) => {
  const title = to.meta.title || 'VTO TOP'
  document.title = title + ' - VTO TOP'
})

export default router
